// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"9efbdb38","188":"ced1cd5e","213":"33aea016","335":"5d3291f1","345":"fe87295d","453":"d855a71b","478":"28264a5a","602":"6c6fd207","955":"d9080be0"}[chunkId] + ".chunk.js";
};